import { useEffect, useState } from 'react'
import { SESSION_LOST_EVENT } from '../utils/gate'

/**
 * Сессия действительно закончилась (7 дней без активности, 30 дней с начала сессии или человека заблокировали
 * в task). В обычной работе сюда не попадаем: открытая вкладка опрашивает API, и это продлевает сессию. Страницу
 * при этом не перезагружаем и никуда не уводим сами: в ней может быть несохранённый черновик. Показываем плашку,
 * вход делает сам человек.
 */
export default function SessionLostBanner() {
  const [loginUrl, setLoginUrl] = useState<string | null>(null)

  useEffect(() => {
    const onLost = (event: Event) => setLoginUrl((event as CustomEvent<{ loginUrl: string }>).detail.loginUrl)
    window.addEventListener(SESSION_LOST_EVENT, onLost)
    return () => window.removeEventListener(SESSION_LOST_EVENT, onLost)
  }, [])

  if (!loginUrl) return null
  return (
    <div role="alert" className="fixed inset-x-0 top-0 z-[100] flex flex-wrap items-center justify-center gap-3 bg-amber-100 px-4 py-2 text-sm text-amber-900 shadow dark:bg-amber-900 dark:text-amber-50">
      <span>Сессия закончилась. Войдите снова, чтобы продолжить работу.</span>
      <a href={loginUrl} className="rounded-md bg-blue-600 px-3 py-1 font-medium text-white hover:bg-blue-700">Войти</a>
    </div>
  )
}
